import React, { useContext, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import TimerIcon from '@mui/icons-material/Timer'
import { ReservationContext } from '../../context/ReservationContext'
import PropTypes from 'prop-types'

export function SeatTimer({ setActiveStep }) {
  const { expiresAt, resetReservation, totalTickets } = useContext(ReservationContext)
  const [expired, setExpired] = useState(false)
  const [remainingMs, setRemainingMs] = useState(() => {
    if (!expiresAt) return null
    return Math.max(0, new Date(expiresAt).getTime() - Date.now())
  })

  useEffect(() => {
    if (!expiresAt) return
    const future = new Date(expiresAt).getTime()
    const remaining = Math.max(0, future - Date.now())
    setRemainingMs(remaining)
    if (remaining > 0) {
      const interval = setInterval(() => {
        const now = Date.now()
        const r = Math.max(0, new Date(expiresAt).getTime() - now)
        setRemainingMs(r)
        if (r <= 0) {
          setExpired(true)
        }
      }, 200)
      return () => clearInterval(interval)
    }
    return () => {}
  }, [expiresAt])

  useEffect(() => {
    if (!expired) return
    resetReservation()
    setExpired(false)
    setActiveStep(2)
  }, [expired, resetReservation, setActiveStep])

  if (remainingMs === null || remainingMs <= 0) return null

  const minutes = Math.floor(remainingMs / 60000)
  const seconds = Math.floor((remainingMs % 60000) / 1000)
  const timeStr = `${String(minutes).padStart(2, '0')} min ${String(seconds).padStart(2, '0')}`

  const isWarning = remainingMs < 120000
  const isCritical = remainingMs < 60000

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        p: 0.75,
        px: 2,
        borderRadius: 2,
        bgcolor: isCritical ? 'rgba(244,67,54,0.1)' : isWarning ? 'rgba(255,152,0,0.08)' : 'rgba(0,0,0,0.03)',
        color: isCritical ? '#c62828' : isWarning ? '#e65100' : 'text.secondary',
        border: isCritical ? '1px solid rgba(244,67,54,0.2)' : isWarning ? '1px solid rgba(255,152,0,0.2)' : '1px solid rgba(0,0,0,0.08)',
        fontSize: '1.05rem',
        fontWeight: 600,
        fontFamily: 'monospace',
        justifyContent: 'flex-end',
        transition: 'all 0.3s ease'
      }}
    >
      {isCritical ? <WarningAmberIcon fontSize='small' /> : <TimerIcon fontSize='small' sx={{ opacity: 0.6 }} />}
      <Typography variant='body1' component='span'>
        {totalTickets === 1 ? 'Place bloquée pour' : 'Places bloquées pour'} : <strong>{timeStr}</strong>
      </Typography>
    </Box>
  )
}

SeatTimer.propTypes = {
  setActiveStep: PropTypes.func.isRequired
}
